export default {
  title: '域名转移服务协议',
  content:
  '<p> 感谢您选择河北识道网络科技有限公司（以下简称“识道网络”）为您提供的域名转移服务。</p>\n' +
      '<p> 本协议是识道网络与您就使用域名转移相关服务所订立的有效合约，您通过网络页面点击确认或以其他方式选择接受本服务协议，或实际使用识道网络域名转移服务，即表示您与识道网络已达成协议并同意接受本服务协议的全部约定内容。</p>\n' +
      '<p> 在接受本协议前，请您务必仔细阅读、充分理解各条款内容，如果您对本协议的条款有任何疑问，请通过识道网络公布的联系方式进行咨询，识道网络将向您解释条款内容。如果您不同意本服务协议的任意内容，或者无法准确理解识道网络对条款的解释，请不要进行后续操作。</p>\n' +
      '<p><br></p>\n' +
      '<h3><strong>1.定义及解释</strong></h3>\n' +
      '<p> 1.1 本协议中的“您”是指：所有使用识道网络域名转移服务的主体（包括但不限于个人、团队、公司、组织等），或称“用户”。</p>\n' +
      '<p> 1.2 “域名转移”是指：域名从当前注册商转移到另一个注册商，之后由转移后的注册商提供相关服务。</p>\n' +
      '<p><br></p>\n' +
      '<h3><strong>2.协议的生效和适用范围</strong></h3>\n' +
      '<p> 2.1 本协议自用户确认本协议之时即刻生效。如用户未点击确认本协议，但事实上已经在使用识道网络域名转移服务或履行本协议，则本协议会在用户的事实行为首次发生之时即生效；</p>\n' +
      '<p> 2.2 本协议包括本协议正文及所有识道网络已经发布或将来可能发布的关于识道网络域名转移服务的各类规则、规范、通知和公告等（以下合称“规则”），所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力；</p>\n' +
      '<p><br></p>\n' +
      '<h3><strong>3.用户的权利与义务</strong></h3>\n' +
      '<p> 3.1 您理解并承诺：遵守国家域名主管机关、域名注册管理机构CNNIC（包括但不限于《中国互联网络域名管理办法》、《中国互联网络信息中心域名争议解决办法》、《中国互联网络信息中心域名争议解决办法程序规则》、ICANN（包括但不限于ICANN下任意一个国际通用顶级域名注册机构和CNNIC等）的相关政策和规定以及域名争议解决办法（UDRP）等；</p>\n' +
      '<p> 3.2 您务必确保在识道网络上转移的域名信息具有真实性、合法性、有效性。不得冒充他人、不得利用他人的名义发布任何信息、不得恶意使用注册帐户导致其他用户误认；若出现此类情况，识道网络有权立即停止提供服务，收回识道网络域名帐号并由相关用户承担由此而产生的一切责任；</p>\n' +
      '<p> 3.3 您理解并保证：所提交的域名申请不涉及任何争议、纠纷、诉讼、仲裁等，若出现此类问题，您务必立即通知识道网络，并尽可能避免识道网络卷入不必要的纠纷；</p>\n' +
      '<p> 3.4 您理解并保证：您的域名一旦从识道网络转出成功，有关此域名的相关事宜与识道网络无关；</p>\n' +
      '<p> 3.5 用户本人以及所有拥有用户帐户使用权的人，只要根据注册管理机构的转移规则，提供符合识道网络要求的材料，都视为是用户本人向识道网络提出的转移；</p>\n' +
      '<p> 3.6 您理解并保证遵守以下域名转移规则：</p>\n' +
      '<p> 3.6.1 域名处于正常状态，与任何正在解决的域名争议及纠纷无关、无冻结、无锁定、转移中等状态；</p>\n' +
      '<p> 3.6.2 域名不处于在司法机构、仲裁机构或域名争议解决机构处理期间；</p>\n' +
      '<p> 3.6.3 域名不处于拖欠注册费用状态中、不处于已过期、赎回期；</p>\n' +
      '<p> 3.6.4 不存在任何未授权转移的情况；</p>\n' +
      '<p> 3.6.5 国际域名续费或刚转移注册商不满60天再次申请转移注册商有可能会导致年限不增加，由此造成经济损失由您自行承担；</p>\n' +
      '<p> 3.6.6 域名成功转入识道网络，过期时间会相应的增加一年，但域名有效年限不会超过10年。</p>\n' +
      '<p> 3.6.7 域名转移注册商需要遵循我司根据注册局要求制定的流程和规则；</p>\n' +
      '<p> 3.6.8 域名转移注册商到识道网络，除3.6.5、3.6.6中的特殊情况外，系统将扣除转入费用为您所填写的域名自动续费一年；</p>\n' +
      '<p> 3.7 域名转移到其他注册商前需要将域名过户到您的模板下，并且取消隐私保护。由于转出前未过户到您的模板下或未取消隐私保护，导致转移失败或新的服务商信息无法更新等情况，识道网络将不承担责任；</p>\n' +
      '<p> 3.8 获取到域名转移密码后，需要您自行保管，并在转移密码有效期内到新的服务商提交转入，由于转移密码自行保管不善丢失或泄露，导致域名转移失败或被盗转，识道网络将不承担责任；</p>\n' +
      '<p> 3.9 在转移过程中，如果您自行取消或您本人以及所有拥有帐户使用权的人提交申请取消转出，则视为自动放弃转移；</p>\n' +
      '<p> 3.10 您理解并同意：域名注册不满两个月，无法转移注册商；</p>\n' +
      '<p><br></p>\n' +
      '<h3><strong>4.识道网络的权利与义务</strong></h3>\n' +
      '<p> 4.1 识道网络为您提供相关的注册商转移服务，包括但不限于以下服务：域名转入、域名转出；</p>\n' +
      '<p> 4.2 识道网络保证您域名转移流程符合ICANN（包括但不限于ICANN下任意一个国际通用顶级域名注册机构等）和CNNIC的相关政策和规定；</p>\n' +
      '<p> 4.3 您理解并同意：应根据识道网络对于转移服务的要求及时提供相应的身份证明等资料，并保证提供的资料或信息正确、真实的，否则识道网络有权拒绝向您提供相关服务；</p>\n' +
      '<p> 4.4 若域名转移过程中发现域名有存在纠纷、争议、仲裁、被盗等情况的，识道网络有权随时停止、取消您的域名转移申请，并根据要求进行域名冻结等操作；</p>\n' +
      '<p> 4.5 您在域名转移过程中，如有遇到问题，识道网络有义务协助进行解决，以帮助您顺利完成转移。但识道网络不因此承担其中由于非我司原因导致的用户损失；</p>\n' +
      '<p> 4.6 识道网络不对外公开或向第三方提供用户所提交的资料，除非：</p>\n' +
      '<p> 4.6.1 事先获得用户的明确授权；</p>\n' +
      '<p> 4.6.2 根据有关的法律法规要求；</p>\n' +
      '<p> 4.6.3 按照相关政府主管部门的要求；</p>\n' +
      '<p> 4.6.4 解决举报事件、提起诉讼而提交的；</p>\n' +
      '<p> 4.6.5 为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的；</p>\n' +
      '<p><br></p>\n' +
      '<h3><strong>5.费用与支付</strong></h3>\n' +
      '<p> 5.1 您同意并按照识道网络所公布的收费标准向识道网络缴纳相关域名转入费用，并且转入成功后，每一次续期都应适用续期时的收费标准，您同意并保证如因收费标准调整产生的任何纠纷，识道网络、CNNIC、ICANN有免于诉讼的权利。在接受本条款之同时，您应将转入域名的全部款项支付给识道网络，同时您理解域名转入成功后，所缴纳的费用不可退回；</p>\n' +
      '<p> 5.2 域名转入过程中，转入的款项会全额冻结，待域名转入成功后，款项正式扣除；</p>\n' +
      '<p> 5.3 您理解并同意：当您的账户下涉及欠款时，识道网络有权拒绝您的转移申请；</p>\n' +
      '<p> 5.4 若域名的总期限未超过10 年，域名转入成功后，域名的到期时间延长一年。该情况的例外是，国际域名距离上次转移注册商或续费不足60天，提交转入后由于注册局的原因，可能导致域名的注册年限不增加，用户理解并同意该情况下，域名转入的费用不予退还；</p>\n' +
      '<p><br></p>\n' +
      '<h3><strong>6.服务的使用、变更、中断及终止</strong></h3>\n' +
      '<p> 6.1 在转移成功之前，如果您自行取消，或您本人以及帐户使用权的人取消，视为自动放弃转移，转移的费用退回用户ID账户下，转移服务终止；</p>\n' +
      '<p> 6.2 由于域名转移密码错误或原注册商拒绝转移的情况导致域名转入失败，识道网络不收取费用；</p>\n' +
      '<p><br></p>\n' +
      '<h3><strong>7.不可抗力及其他免责事由</strong></h3>\n' +
      '<p> 7.1 识道网络在此明确声明对识道网络的服务不作任何明示或暗示的保证，包括但不限于识道网络服务的可适用性、没有错误或疏漏、持续性、安全性、准确性、可靠性、适用于某一特定用途;</p>\n' +
      '<p> 7.2 您理解并同意：在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，识道网络将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失识道网络在法律允许的范围内免责;</p>\n' +
      '<p> 7.3 在法律允许的范围内，识道网络对以下情形导致的服务中断或受阻无需对您或第三方承担责任：</p>\n' +
      '<p> 7.4 若您对识道网络提供的收费标准、服务使用期限等费用结算事项的通知内容有异议，应及时以书面形式告知识道网络，识道网络收到您的书面告知会进行核实，否则，视为您认可识道网络提供的费用结算事项的通知内容，双方应按照识道网络提供的费用结算事项的通知内容，进行费用的结算及支付等；</p>\n' +
      '<p> 7.3.1 受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>\n' +
      '<p> 7.3.2 用户或识道网络的电脑软件、系统、硬件和通信线路出现故障；</p>\n' +
      '<p> 7.3.3 用户操作不当；</p>\n' +
      '<p> 7.3.4 用户通过非识道网络授权的方式使用本服务；</p>\n' +
      '<p> 7.3.5 其他识道网络无法控制或合理预见的情形；</p>\n' +
      '<p> 7.4 您理解并同意：在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，识道网络不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：</p>\n' +
      '<p> 7.4.1 来自他人匿名或冒名的含有威胁、诽谤、或非法内容的信息；</p>\n' +
      '<p> 7.4.2 因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</p>\n' +
      '<p> 7.4.3 其他因网络信息或用户行为引起的风险；</p>\n' +
      '<p> 7.5 您理解并同意，本域名转移协议并非为某些特定目的而设计，包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，识道网络不承担法律责任；</p>\n' +
      '<p> 7.6 识道网络依据本协议约定获得处理违法违规内容的权利，该权利不构成识道网络的义务或承诺，识道网络不能保证及时发现违法行为或进行相应处理；</p>\n' +
      '<p> 7.7 在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息；涉及财产操作的，请一定先核实对方身份，并请经常留意识道网络有关防范诈骗犯罪的提示；</p>\n' +
      '<p><br></p>\n' +
      '<h3><strong>8.管辖及法律适用</strong></h3>\n' +
      '<p> 8.1 本协议签订地为中华人民共和国北京市海淀区；</p>\n' +
      '<p> 8.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律；如无相关法律规定的，则应参照通用国际域名行业惯例；</p>\n' +
      '<p> 8.3 若您和识道网络之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖；</p>\n' +
      '<p> 8.4 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据；</p>\n' +
      '<p> 8.5 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力；</p>'
};
